import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService, DialogsService } from '../../custom-material/Services/';

import { globalData } from 'src/app/main/Models/global.model';
import { BuildingModel, UserModel, IncidentModel } from '../../main/Models/';
import { toollist } from './incident-sheet.tools';

@Component({
  selector: 'incident-sheet',
  templateUrl: './t_incident-sheet.component.html',
  styleUrls: ['./incident-sheet.component.less']
})
export class IncidentSheetComponent implements OnInit {

  incident: IncidentModel;
/*
  @Output()
  closeTriggered: EventEmitter<IncidentModel> = new EventEmitter();

  @Output()
  saveTriggered: EventEmitter<IncidentModel> = new EventEmitter();
*/
  editMode:boolean = false;


  constructor(
    private apiService: ApiService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: DialogsService,
    public gd:globalData) { 
      this.gd.showChooser = false;
      this.gd.toolService = this;
      this.gd.toollist = toollist;
      this.gd.headerTitle = "Incident";
      this.gd.headerIcon = 'sync_problem';
    }

  ngOnInit() {
  	//if(this.incident.id == undefined) this.editMode = true;
    this.loadIncident().then(()=>{
      this.gd.headerTitle = 'Incident : '+this.incident.nature;
      this.gd.headerBuilding = this.incident.building;
    });
  }

  ngOnDestroy()
  {
    this.save();
  }

  loadIncident()
  {
    return new Promise((resolve, reject)=>{
      let id = +this.route.snapshot.params['incident'];
      /*if(id==undefined) {   //new n'est pas ici
        let buildingId =  +this.route.snapshot.params['incident'];
        this.incident = new IncidentModel({ 
          building: this.gd.findBuildingById(buildingId)
        });
        this.editMode = true;
      }*/


      if(this.gd.current!= undefined 
      && this.gd.current.constructor.name == 'IncidentModel'
      && this.gd.current.id == id) {
        this.incident = this.gd.current;
        resolve(true);
      }

      this.snackBar.open('Chargement en cours');
      this.apiService.getOneFromServer('incident',id)
      .then(s => s.subscribe((response:any) => {
        this.incident = new IncidentModel(response);
        this.snackBar.dismiss();
        resolve(true);
      }));
    });
  }


  edit()
  {
    //this.editMode = true;
    this.router.navigate(['/incidents','edit',this.incident.id]);
  }



  save()
  {
    setTimeout(()=>{ this.snackBar.open('Sauvegarde en cours') }, 0);
    if(!this.incident.id) {
      this.apiService.SaveToServer('incident', this.incident.export())
        .then(s => s.subscribe((response:any) => {
          this.incident = new IncidentModel(response);
          setTimeout(()=>{ this.snackBar.open('Sauvegarde terminé') }, 0);
          setTimeout(()=>{ this.snackBar.dismiss() }, 2000);
        }));
    } else {
      this.apiService.UpdateToServer('incident', this.incident.export())
        .then(s => s.subscribe((response:any) => {
          this.incident.exchange(response);
          setTimeout(()=>{ this.snackBar.open('Sauvegarde terminé') }, 0);
          setTimeout(()=>{ this.snackBar.dismiss() }, 2000);
        }));
    }

  }

  delete()
  {
    this.dialogService.confirm('incidentsheet-delete-confirm-message')
        .subscribe(res => {
          if(res) {
            this.apiService.DeleteFromServer('incident', this.incident)
              .then(s => s.subscribe(
                response => {
                  this.router.navigate(['/incidents']);
                },
                err => console.log("incident.delete error", err)
              ) );
          }
        });
  }

  /*cancel()
  {
  	this.editMode = false;
    if(!this.incident.id) this.close();
  }

  close()
  {
  	this.closeTriggered.emit(this.incident);
  }*/
/*
  get userIsSuperior()
  {
    let user = this.apiService.connectedUser;
    let redactor = this.incident.redactor;

    return;
  }
*/
}
